<template>
    <div class="flex flex-col md:flex-row border-t border-light-gray md:border-t-2 pl-10 py-2 md:py-4 bg-white fixed inset-x-0 bottom-0" v-if="isOpen">
        <div class="w-full md:w-2/3 text-left text-sm md:text-base">
                Nuestro sitio utiliza cookies y tecnologías similares ("cookies"). Al hacer uso de este sitio confirmas estar de acuerdo en el uso de cookies, al igual que en nuestro
                <a href="https://www.hyundai.com.mx/privacidad/" target="_blank" rel="noopener noreferrer" class="text-dark-blue font-black">Aviso de Privacidad</a> y
                <a href="https://www.hyundai.com.mx/terminos/" target="_blank" rel="noopener noreferrer" class="text-dark-blue font-black">Términos de Uso</a>. Para más información conoce nuestra
                <a href="https://www.hyundai.com.mx/politica-cookies/" target="_blank" rel="noopener noreferrer" class="text-dark-blue font-black">Política de Cookies</a>.
        </div>
        <div class="flex justify-center items-center my-3 md:flex-start w-full md:w-1/3 h-full">
            <button
            class="block text-center bg-dark-blue text-white md:text-lg text-sm md:text-md py-2 px-3 hover:bg-dark-blue2"

            @click="accept">
            {{ buttonTextAccept }}
        </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        buttonTextAccept: {
            type: String,
            default: 'Aceptar y Cerrar'
        },
    },
    data() {
        return {
            isOpen: false
        }
    },
    created() {

        if ( !this.getCookiesAccepted() === true ){
            this.isOpen = true
        }
    },
    methods: {
        getCookiesAccepted(){

            return localStorage.getItem('CookiesAccepted-HyundF2:' + this.checkEnvironment(), true);
        },
        accept(){
            this.isOpen = false;
            localStorage.setItem('CookiesAccepted-HyundF2:' + this.checkEnvironment(), true)
        },
        checkEnvironment(){
            const currentUrl = window.location.host;
            switch (currentUrl){
                case 'dealersdev.alkemymx.com':
                    return 'STG'
                case 'hyundaidistribuidor.com.mx':
                    return 'PROD'
                default:
                    return 'LOCAL'

            }
        }
    }
}
</script>
